export class ProjectActivityConstants {
    
    public static activityTypesValues = {
        activityTypeSingleResponsibilityValue: '1',
        activityTypeWholeTeamResponsibilityValue: '2',
        activityTypeDuplicateForEachTeamMemberValue: '3'
    }
}